import { graphqlPost } from "api/graphqlClient";
import NotificationService from "components/Notification/Notification.service";
import RestErrorNotification from "components/Notification/RestErrorNotification";
import { call, takeEvery } from "redux-saga/effects";
import { actions as metaTypeActions } from "./MetaType.actions";

export function* fetchMetaTypeData({ promise, params }) {
    try {
        const metaTypeAPI = yield graphqlPost(params);
        yield call(promise.resolve, metaTypeAPI?.data);
    } catch (error) {
        yield call(promise.reject, error?.response?.data || error);
        NotificationService.error(
            <RestErrorNotification titleOverride={"Failed to fetch"} error={error} />
        );
    }
}

export default [takeEvery(metaTypeActions.START_FETCH_META_TYPE, fetchMetaTypeData)];
